<template>
  <div
    class="main-view"
  >
    <PageHeader
      class="main-view__header"
      @clickVideo="modalOpened = true"
    />

    <div class="main-view__container">
      <h2 class="main-view__title main-view__title--carousel">
        {{ $store.state.config.medals.description }}
      </h2>
      <CarouselLayout />

      <MedalsLayout class="main-view__medals" />

      <StoreLocator class="main-view__store-locator" />

      <h2 class="main-view__title main-view__title--coins">
        {{ $store.state.config.coins.description }}
      </h2>
      <CoinsLayout />
    </div>

    <PageFooter class="main-view__footer" />

    <div
      v-if="modalOpened"
      ref="modal"
      class="main-view__modal"
    >
      <Modal
        :close-label="$store.state.config.close"
        @close="modalOpened = false"
      >
        <PlayerVideo />
      </Modal>
    </div>
  </div>
</template>

<script>

import CarouselLayout from '@/components/carousel/Layout.vue';
import CoinsLayout from '@/components/products/coins/Layout.vue';
import MedalsLayout from '@/components/products/medals/Layout.vue';
import Modal from '@/components/modal/Modal.vue';
import PageFooter from '@/components/footer/PageFooter.vue';
import PageHeader from '@/components/header/PageHeader.vue';
import PlayerVideo from '@/components/video/PlayerVideo.vue';
import StoreLocator from '@/components/store/StoreLocator.vue';

export default {
  name: 'MainView',
  components: {
    CarouselLayout,
    CoinsLayout,
    MedalsLayout,
    Modal,
    PageFooter,
    PageHeader,
    PlayerVideo,
    StoreLocator,
  },

  data() {
    return {
      modalOpened: false,
    };
  },

  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
  },

  watch: {
    modalOpened(value) {
      document.body.style.overflow = value ? 'hidden' : '';
    },
  },

  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },

  methods: {
    handleResize() {
      if (window.innerWidth <= parseInt(this.$tokens.bp_mobile, 0)) {
        this.$store.commit('setMobile', true);
      } else {
        this.$store.commit('setMobile', false);
      }
    },
  },
};
</script>


<style lang="stylus" scoped>
// We are using Rupture for breapoints management cf https://jescalan.github.io/rupture/
// breakpoints are listed in /src/tokens/breakpoints.yml
// same for colors and font-sizes
.main-view {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: auto;
  height: auto;
}

.main-view__header {
  max-width: 1920px;
  margin: 0 auto;
}

.main-view__modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;

  width: 100%;
  height: 100%;
}

.main-view__container {
  position: relative;
  z-index: 0;

  box-sizing: border-box;
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  padding: 0 10px;

  +desktop() {
    padding: 0 20px;
  }

  +above(xl) {
    padding: 0 40px;
  }
}

.main-view__title {
  @extends $txt-title-1;

  &--carousel {
    margin: 40px 0 10px 0;

    +desktop() {
      text-align: left;
      margin: 0 0 10px calc(50% - 100px);
      white-space: nowrap;
    }
  }

  &--coins {
    margin: 88px 0 10px 0;
    +desktop() { margin-top: 93px; }
  }
}

.main-view__medals {
  max-width: 1400px;
  margin: 30px auto 0 auto;
}

.main-view__store-locator {
  max-width: 1400px;
  margin: 50px auto 0 auto;
}

.main-view__footer {
  margin-top: 70px;
}
</style>
